import { useTranslation } from 'react-i18next'
interface WriteSpeakSectionProps {
  title: string
  titleHighlight: string
  body: string
  emphasis: string
}

/**
 * #06 Write & speak — text block + full-bleed band image below.
 * Desktop: `writespeak.webp`, Mobile: `writespeak-m.webp` via <picture>.
 * Figma: node 123:1692 (desktop) / 194:5784 (mobile)
 */
export function WriteSpeakSection({
  title,
  titleHighlight,
  body,
  emphasis,
}: WriteSpeakSectionProps) {
  const { t: mt } = useTranslation('marketing')

  return (
    <section id="write-speak" data-marketing-section="" className="w-full bg-qb-bg overflow-hidden">
      {/* Text block */}
      <div className="mx-auto max-w-[1136px] px-6 lg:px-0 pt-20 lg:pt-[120px] pb-10 lg:pb-[80px]">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-10 items-center lg:items-start text-center lg:text-left">
          {/* Left: title */}
          <div className="flex flex-col gap-2 flex-1">
            <p className="font-['Pretendard',sans-serif] font-bold text-[28px] lg:text-[40px] leading-[1.2] tracking-[-0.6px] text-qb-text-high whitespace-pre-line">
              {title}
            </p>
            <p className="font-['Pretendard',sans-serif] font-bold text-[28px] lg:text-[40px] leading-[1.2] tracking-[-0.6px] text-qb-primary">
              {titleHighlight}
            </p>
          </div>

          {/* Right: body + emphasis */}
          <div className="flex flex-col gap-10 flex-1">
            <p className="font-['Pretendard',sans-serif] font-normal text-[18px] lg:text-[20px] leading-[1.5] tracking-[-0.6px] text-qb-text-mid whitespace-pre-line">
              {body}
            </p>
            <p className="font-['Pretendard',sans-serif] font-bold text-[22px] lg:text-[28px] leading-[1.4] tracking-[-0.6px] text-qb-text-high whitespace-pre-line">
              {emphasis}
            </p>
          </div>
        </div>
      </div>

      {/* Full-bleed band image */}
      <picture>
        <source media="(min-width: 1024px)" srcSet="/marketing/main/writespeak.webp" />
        <img
          src="/marketing/main/writespeak-m.webp"
          alt={mt('WriteSpeakSection.alt_358')}
          className="w-full h-[280px] object-cover object-center lg:h-auto lg:object-bottom"
          style={{ aspectRatio: '1920/360' }}
        />
      </picture>
    </section>
  )
}
